<template>
  <div v-if="examSet">
    <div class="text-center m-1 font-weight-bold">
      Pytanie {{ progress.current.toFixed(0) }} / {{ progress.max }}
    </div>
    <b-progress
      :value="progress.current"
      :max="progress.max"
      show-value
      animated
      class="mb-3"
      variant="secondary"
      :striped="true"
    >
    </b-progress>
    <b-row class="mb-3">
      <b-col
        v-show="progress.current - 1 === index"
        lg="12"
        v-for="(question, index) in examSet"
        :key="index"
        class="text-center"
      >
        <course-exam-question
          v-if="
            question.type === 'one_answer' ||
            question.type === 'multiple_answers'
          "
          :question="question"
          :questionIndex="index"
          :examImagesPath="examImagesPath"
          :progressCurrent="progress.current - 1"
          v-on:onToggleNextBtn="onToggleNextBtn"
          v-on:onChangeAnswer="onChangeAnswer"
        ></course-exam-question>
        <course-exam-question-grouped
          v-if="question.type === 'grouped_answers'"
          :question="question"
          :questionIndex="index"
          :examImagesPath="examImagesPath"
          :progressCurrent="progress.current - 1"
          v-on:onToggleNextBtn="onToggleNextBtn"
          v-on:onChangeAnswer="onChangeAnswer"
        >
        </course-exam-question-grouped>
        <course-exam-question-sorted
          v-if="question.type === 'sorted_answers'"
          :question="question"
          :questionIndex="index"
          :examImagesPath="examImagesPath"
          :progressCurrent="progress.current - 1"
          v-on:onToggleNextBtn="onToggleNextBtn"
          v-on:onChangeAnswer="onChangeAnswer"
        >
        </course-exam-question-sorted>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col lg="6" class="text-right">
        <b-button
          v-show="progress.current > 1"
          v-on:click="onPreviousQuestion"
          v-if="false"
          class="color-white"
          >Poprzednie pytanie</b-button
        >
      </b-col>
      <b-col lg="6" class="text-left">
        <b-popover
          ref="nextBtnPopover"
          variant="danger"
          placement="top"
          target="next-btn-popover"
          :show="nextBtnShowPopover"
        >
          <span class="color-red">Nie udzielono odpowiedzi</span>
        </b-popover>

        <div id="next-btn-popover" class="w-50">
          <b-button
            v-if="progress.current < progress.max"
            v-on:click="onNextQuestion"
            class="w-100 ml-3 p-3 font-size-15 color-white"
            >Następne pytanie <b-icon-chevron-right class="font-size-15"
          /></b-button>
          <b-button
            v-else-if="progress.current === progress.max"
            v-on:click="onEndExam"
            class="w-100 ml-3 p-3 font-size-15"
            variant="success"
            >Zakończ test</b-button
          >
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CourseExamQuestion from './CourseExamQuestion';
import CourseExamQuestionGrouped from './CourseExamQuestionGrouped';
import CourseExamQuestionSorted from './CourseExamQuestionSorted';
import { mapGetters } from 'vuex';

export default {
  name: 'CourseExamQuestions',
  components: {
    CourseExamQuestion,
    CourseExamQuestionSorted,
    CourseExamQuestionGrouped,
  },
  data() {
    return {
      progress: {
        current: 1,
        max: 1,
      },
      nextBtnDisabled: true,
      nextBtnShowPopover: false,
    };
  },
  props: {
    participantId: {},
    examSet: {},
    examImagesPath: {},
  },
  computed: {
    ...mapGetters({
      licence: 'auth/userLicence',
    }),
  },
  created() {
    this.progress.max = this.examSet.length;
    window.dataLayer.push({
      event: 'btnTestNastepnePytanie',
      user_id: this.participantId,
      license_id: this.licence,
      test_question_number: this.progress.current,
    });
  },
  methods: {
    onPreviousQuestion() {
      this.progress.current--;
    },
    onNextQuestion() {
      if (this.nextBtnDisabled) {
        this.showAndEnablePopovers();
      } else {
        window.dataLayer.push({
          event: 'btnTestNastepnePytanie',
          user_id: this.participantId,
          license_id: this.licence,
          test_question: this.progress.current + 1,
        });
        this.hideAndDisablePopovers();
        this.progress.current++;
      }
    },
    showAndEnablePopovers() {
      this.$refs.nextBtnPopover.$emit('enable');
      this.nextBtnShowPopover = true;
    },
    hideAndDisablePopovers() {
      this.$refs.nextBtnPopover.$emit('enable');
      this.nextBtnShowPopover = true;
      this.$nextTick(() => {
        this.nextBtnShowPopover = false;
      });
    },
    onToggleNextBtn(disable) {
      this.nextBtnDisabled = disable;
    },
    onChangeAnswer(answer) {
      this.hideAndDisablePopovers();
      this.$emit('onChangeAnswer', answer);
    },
    onEndExam() {
      if (this.nextBtnDisabled) {
        this.showAndEnablePopovers();
      } else {
        this.hideAndDisablePopovers();
        this.$emit('onEndExam');
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  button {
    opacity: 1 !important;
  }
  .col-form-label {
    font-size: 19px;
  }
  .custom-control-label {
    font-size: 16px;
  }
}
</style>
